class VwStkAraDTO {
    id?: number = null;
    kodu?: string = "";
    barkodNo?: string = "";
    adi?: string = "";
    olcubirimadi?: string = "";
    mevcut?: number = null;
    ambalajbirimadi?: string = "";
    olcubirimId?: number = null;
    ambalajbirimId?: number = null;
    urungrupadi?: string = "";
    receteturadi?: string = "";
    kullanimsekiladi?: string = "";
    saklamakosuladi?: string = "";
    riskgrupadi?: string = "";
    depotanimId?: number = null;
    depodonemId?: number = null;
    yil?: number = null;
    islemtanimId?: number = null;
    talepmiktar?: number = null;
    talepOlcubirimYontem?: number = null;
}
export default VwStkAraDTO;